// import { IHttpService } from 'repository/IHttpService';
// import { IUserService as IUserRepository } from './IAuthService';

export class PermissionRepository implements IPermissionRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getPermissions(): Promise<Permission[]> {
        const response = await this.httpService.get<Data<Permission[]>>('/v1/permission');
        const data = response.data.map((permission: Permission) => ({
            ...permission,
            id: permission.permission_id
        }));
        return data;
    }

    async getProfilePermissions(profileId: number): Promise<any[]> {
        const response = await this.httpService.get<Data<any[]>>(`/v1/profile_r_permission/${profileId}`);
        return response.data;
    }

    async assignProfileReportCategories(profileId: number, categoryReportIds: number[]) {
        try {
            const data = await this.httpService.patch<Data<any>, Record<string, number[]>>(`/v1/profile_r_category_report/${profileId}`, { data: { category_report_ids: categoryReportIds } });
            console.log(data);
            return data;
        } catch (error) {
            console.error("Axios Error:", error);
        }
    }

}
